import React, { Component } from "react";

import "../../../sass/applications.scss";
import imgLogo from "../../../images/logo.png";
import { Link } from "react-router-dom";
import imgLogoPaychex from "../../../images/paychex-logo.png";
import imgBack from "../../../images/Vector.png";
import imgRerun from "../../../images/Rerun.png";
import imgEditApp from "../../../images/edit-app.png";
import imgCopyApp from "../../../images/copy-app.png";
import imgCancelapp from "../../../images/Cancelapp.png";
import imgChangeOwnership from "../../../images/ChangeOwnership.png";
import imgMobileAppDetailMenu from "../../../images/Ellipse.png";
import imgNotifications from "../../../images/notifications.png";
import imgAvatar from "../../../images/avatar-default.png";
import { Dropdown, NavItem, NavLink } from "react-bootstrap";
import config from "../../config";
import AddApplicationModal from "../modals/add-new-application-modal/add-applications-modal";
import HeaderMenu from "../preapps/HeaderMenu";
import EMSBootModal from "../modals/add-new-application-modal/ems-boot-application-modal";

const MOBILE_SCREEN_WIDTH = 767;
const MAIN_URL = config.paymentcloud.MAIN_URL;

class MobileAppDetailHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            showMobileMenu: false,
            CreateUrl: "",
            showCreatedAppModel: false,
            hideMenuOptions: false,
            showEmsBootModal: false,
        };
        this.wrapperRef = React.createRef();
    }

    handleResize = () => {
        this.setState({
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
        });
    };

    handleClickOutside = (event) => {
        if (
            this.state.showMobileMenu &&
            this.wrapperRef &&
            !this.wrapperRef.current.contains(event.target)
        ) {
            this.setState({ showMobileMenu: false });
        }
    };

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        window.addEventListener("mousedown", this.handleClickOutside);
        if (this.props.user && this.props.user.channel == "sales_channel") {
            this.setState({ hideMenuOptions: true });
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleShowMenu() {
        this.setState({ showMobileMenu: true });
    }

    handleShowAddApplicationModel = () => {
        if (this.props.user?.channel == 'isv_channel') {
            this.setState({ showCreatedAppModel: true });
        } else {
            this.setState({ showEmsBootModal: true });
        }
    };

    render() {
        const user = this.props.user;
        let organisation_slug = "";
        if (user.agent_url) {
            if (user.organization) {
                organisation_slug = user.organization.whitelabel_slug;
            }
            if (this.state.CreateUrl.length == 0 && organisation_slug.length) {
                let URLCreate =
                    MAIN_URL + organisation_slug + "/" + user.agent_url;
                this.setState({
                    CreateUrl: URLCreate,
                });
            }
        }
        const { windowWidth, windowHeight, showMobileMenu } = this.state;
        const isMobile = windowWidth < MOBILE_SCREEN_WIDTH;
        const isPcAdmin =
            user && user.role === "admin" && user.organization_id == 1;
        let userName = user.name || "";
        const menuStyle = {};
        if (isMobile) {
            userName = null;
            Object.assign(menuStyle, {
                height: windowHeight + "px",
            });
        }

        return (
            <div>
                <header className="header">
                    <div className="container-fluid">
                        <div className="header-row">
                            {isMobile ? (
                                <>
                                    <div className="header-dashboard-col">
                                        <a
                                            href="javascript:;"
                                            onClick={() =>
                                                this.props.hideAppInfo()
                                            }
                                        >
                                            <img src={imgBack} />
                                        </a>
                                    </div>
                                    <div className="header-user-col_1">
                                        <div className="alert-menu">
                                            <p onClick={this.props.showBanks}>
                                                Assign MSP
                                            </p>
                                        </div>
                                        <div className="header-dashboard">
                                            <a
                                                href="javascript:;"
                                                onClick={() =>
                                                    this.handleShowMenu()
                                                }
                                            >
                                                <img
                                                    className="logo"
                                                    src={imgMobileAppDetailMenu}
                                                    alt="PaymentCloud.com"
                                                />
                                                <img
                                                    className="logo"
                                                    src={imgMobileAppDetailMenu}
                                                    alt="PaymentCloud.com"
                                                />
                                                <img
                                                    className="logo"
                                                    src={imgMobileAppDetailMenu}
                                                    alt="PaymentCloud.com"
                                                />
                                                {showMobileMenu ? (
                                                    <>
                                                        <div
                                                            ref={
                                                                this.wrapperRef
                                                            }
                                                            className="top_right_menu"
                                                        >
                                                            <ul>
                                                                <li>
                                                                    <a
                                                                        href="javascript:;"
                                                                        onClick={() =>
                                                                            this.props.handleCancle()
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                imgCancelapp
                                                                            }
                                                                        />{" "}
                                                                        Cancel
                                                                        Preapp
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a
                                                                        href="javascript:;"
                                                                        onClick={() =>
                                                                            this.props.handleChangeOwner()
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                imgChangeOwnership
                                                                            }
                                                                        />{" "}
                                                                        Change
                                                                        Ownership
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a
                                                                        href="javascript:;"
                                                                        onClick={() =>
                                                                            this.props.handlePdfRun()
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                imgRerun
                                                                            }
                                                                        />{" "}
                                                                        Re-run
                                                                        Application
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a
                                                                        href="javascript:;"
                                                                        onClick={() =>
                                                                            this.props.handleAppCopy()
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                imgCopyApp
                                                                            }
                                                                        />{" "}
                                                                        Copy
                                                                        Application
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a
                                                                        href="javascript:;"
                                                                        onClick={() =>
                                                                            this.props.handleEditApplication()
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                imgEditApp
                                                                            }
                                                                        />{" "}
                                                                        Edit
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                            </a>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="header-dashboard-col">
                                        <div className="header-dashboard">
                                            <a href="/">
                                                {user?.organization_id ===
                                                config.paymentcloud
                                                    .PAYCHEX_ORG_ID ? (
                                                    <img
                                                        className="logo"
                                                        src={imgLogoPaychex}
                                                        alt="PaymentCloud.com"
                                                    />
                                                ) : (
                                                    <img
                                                        className="logo"
                                                        src={imgLogo}
                                                        alt="PaymentCloud.com"
                                                    />
                                                )}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="header-menu-col">
                                        <div className="header-menu">
                                            <ul className="header-tabs-groupwise">
                                                <li>
                                                    {this.props.user
                                                        ?.organization
                                                        ?.show_create ? (
                                                        <a
                                                            className="new-app-button"
                                                            title="Create"
                                                            onClick={() =>
                                                                this.handleShowAddApplicationModel()
                                                            }
                                                        >
                                                            <svg
                                                                width="12"
                                                                height="12"
                                                                viewBox="0 0 12 12"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    clipRule="evenodd"
                                                                    d="M6.75 0H5.25V5.25H0V6.75H5.25V12H6.75V6.75H12V5.25H6.75V0Z"
                                                                    fill="white"
                                                                />
                                                            </svg>
                                                            <span>Create</span>
                                                        </a>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </li>
                                                {isMobile ? (
                                                    ""
                                                ) : (
                                                    <HeaderMenu
                                                        isPcAdmin={isPcAdmin}
                                                        hideMenuOptions={
                                                            this.state
                                                                .hideMenuOptions
                                                        }
                                                        user={user}
                                                        currentRoute={
                                                            this.props
                                                                .currentRoute
                                                        }
                                                        tabShowActive={(path) =>
                                                            this.props.tabShowActive(
                                                                path,
                                                            )
                                                        }
                                                    />
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="header-user-col">
                                        <div className="alert-menu">
                                            <img src={imgNotifications} />
                                        </div>
                                        <div className="header-user">
                                            {user.role ? (
                                                <>
                                                    <img src={imgAvatar} />
                                                    <Dropdown as={NavItem}>
                                                        <Dropdown.Toggle
                                                            id="nav-dropdown"
                                                            as={NavLink}
                                                        >
                                                            <div className="user">
                                                                <span>
                                                                    {
                                                                        this
                                                                            .props
                                                                            .header_user_name
                                                                    }
                                                                </span>
                                                                <span>
                                                                    {user &&
                                                                    user.role
                                                                        ? user.role
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item
                                                                onClick={
                                                                    this.props
                                                                        .onLogout
                                                                }
                                                            >
                                                                Logout
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </header>
                {this.state.showCreatedAppModel === true && (
                    <AddApplicationModal
                        showCreatedAppModel={this.state.showCreatedAppModel}
                        handleCloseCreatedAppModel={() =>
                            this.setState({ showCreatedAppModel: false })
                        }
                        getPreappData={() => this.props.getPreappData()}
                        fullApplicationUrl={this.state.CreateUrl}
                        user={user}
                    />
                )}

                {this.state.showEmsBootModal && (
                    <EMSBootModal
                        isOpen={this.state.showEmsBootModal}
                        close={() => this.setState({ showEmsBootModal: false })}
                        user={this.props.user}
                    />
                )}
            </div>
        );
    }
}

export default MobileAppDetailHeader;
